/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/253-wondering2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM4 5a1 1 0 112 0 1 1 0 01-2 0zm1.176 7.6l-.351-1.2 6.828-2 .351 1.2-6.828 2z"/>'
  }
})
